import React from "react";
import Section from "~components/layout/section";

interface IInfomeetingFormError {
  section: any;
}

const InfomeetingFormError = (props: IInfomeetingFormError) => {
  return <Section {...props.section} />;
};

export default InfomeetingFormError;
